import store from '../store/index'
import isEmpty from '../helpers/isEmpty'
//-------------------------------------
// create changed characteristic entry
//-------------------------------------
export default function createChangedCharacteristicEntry(pfx, character) {
  // console.log('--------------------------------')
  // console.log('IN createChangedCharacteristicEntry')
  //****************************************
  // (for new characters where characteristic changed from race default during creation -
  // characteristic id added after characteristic creation)
  //****************************************
  let char = null
  //-----------------
  // set char values
  //------------------
  const val_rolled = character[pfx + '_rolled']
  const val_improvs = character[pfx + '_improvs_tot']
  //---------------------------
  // check character/id exists
  //---------------------------
  if (character && !isEmpty(character.id) && character.id !== 0) {
    //---------------------------------------
    // get all characteristics for character
    //---------------------------------------
    let character_chars = store.getters['characters/getCharacterCharacteristics'](character.id)
    //------------------------------------------------
    // get specific changed characteristic (to get id)
    //-------------------------------------------------
    char = character_chars.find((a) => a.name == pfx)
    //   console.log('char name ====>', char.name)
    //   console.log('char id ====>', char.id)
    //   console.log('val_rolled ====>', val_rolled)
    //   console.log('val_improvs ====>', val_improvs)
  }
  //----------------
  // set char entry (name is temporary - allows searching - removed before updates)
  //----------------
  let char_entry = {
    name: pfx,
    type: 'characteristic',
    id: char ? char.id : null, // if characteristic exists, use its id; otherwise, it will be created later
    payload: {
      rolled: val_rolled,
      improvs_tot: val_improvs,
    },
  }
  //----------------------
  // allow for pow change
  //----------------------
  // if (pfx == 'pow') {
  //   char_entry.payload.integs_tot = character.pow_integs_tot
  // }

  return char_entry
}
